// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__29Ofj","left":"InfoRow_left__3Kz4-"};